import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("trueline_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password, remember_me = false) => {
    const res = await api.post("/auth/login", { email, password, remember_me });
    localStorage.setItem("trueline_token", res.data.access_token);
    localStorage.setItem("trueline_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (payload) => {
    const res = await api.post("/auth/register", payload);
    localStorage.setItem("trueline_token", res.data.access_token);
    localStorage.setItem("trueline_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("trueline_token");
    localStorage.removeItem("trueline_user");
    setUser(null);
  };

  useEffect(() => {
    if (user) {
      api.get("/auth/me")
        .then((r) => {
          if (r?.data) {
            localStorage.setItem("trueline_user", JSON.stringify(r.data));
            setUser(r.data);
          }
        })
        .catch(() => logout());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
